const PRICING_FIELDS = [
  "priceCardElementId",
  "priceCardId",
  "priceCardVersion",
  "unit",
  "pricingOverride",
];

const toComparablePrice = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? Math.round(number * 100) / 100 : null;
};

export const clearPriceCardSnapshot = (lineItem) => {
  const next = { ...lineItem };
  PRICING_FIELDS.forEach((field) => {
    delete next[field];
  });
  return next;
};

/**
 * Copies the live tariff values into a line item. This is intentionally only
 * called on selection or an explicit refresh; saved values never auto-update.
 */
export const snapshotPriceCardElement = (lineItem, element) => {
  const quantity = Number(lineItem.quantity ?? 1);
  const unitPrice = toComparablePrice(element.unitPrice) ?? 0;

  return {
    ...clearPriceCardSnapshot(lineItem),
    product: null,
    productId: element.productId || null,
    description: element.description || element.name || lineItem.description,
    quantity,
    unitPrice,
    total: Math.round(quantity * unitPrice * 100) / 100,
    isCustom: false,
    persistProduct: false,
    priceCardElementId: element.id,
    priceCardId: element.priceCardId || null,
    priceCardVersion: element.priceCardVersion ?? null,
    unit: element.unit || "",
  };
};

export const compareLineItemToLiveElement = (lineItem, element) => {
  if (!element) {
    return { status: "missing", changes: [] };
  }

  const comparisons = [
    ["unitPrice", toComparablePrice(lineItem.unitPrice), toComparablePrice(element.unitPrice)],
    ["unit", lineItem.unit || "", element.unit || ""],
    ["priceCardId", lineItem.priceCardId || null, element.priceCardId || null],
    [
      "priceCardVersion",
      lineItem.priceCardVersion ?? null,
      element.priceCardVersion ?? null,
    ],
  ];
  const changes = comparisons
    .filter(([, saved, live]) => saved !== live)
    .map(([field, saved, live]) => ({ field, saved, live }));

  return { status: changes.length ? "changed" : "current", changes };
};

export const refreshLineItemFromLiveElement = (lineItem, element) =>
  snapshotPriceCardElement(lineItem, element);

